import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'header-main',
  standalone: true,
  imports: [CommonModule],
  host: { ngSkipHydration: 'true' },
  styleUrls: ['./header-main.scss'],
  templateUrl: './header-main.html'
})
export class HeaderComponent {
  constructor(
  ) { }
}
